<template>
  <validation-observer ref="simpleRules">
    <!-- Nama -->
    <b-form-group
      label-for="v-title"
      label-cols-md="4"
    >
      <template #label>
        Nama
        <b-badge
          variant="light-secondary"
        >
          Wajib
        </b-badge>
      </template>
      <validation-provider
        #default="{ errors }"
        name="Nama"
        rules="required"
      >
        <b-form-input
          id="v-title"
          v-model="form.title"
          :state="errors.length > 0 ? false : null"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Slug -->
    <b-form-group
      label-for="v-slug"
      label-cols-md="4"
      label-class="pt-0"
    >
      <template #label>
        Slug
        <b-badge
          variant="light-secondary"
        >
          Wajib
        </b-badge>
      </template>
      <validation-provider
        #default="{ errors }"
        name="Slug"
        rules="required"
      >
        <b-form-input
          id="v-slug"
          v-model="form.slug"
          :state="errors.length > 0 ? false : null"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Type -->
    <b-form-group
      label="Lokasi"
      label-for="v-type"
      label-cols-md="4"
    >
      <template #label>
        Lokasi
        <b-badge
          variant="light-secondary"
        >
          Wajib
        </b-badge>
      </template>
      <validation-provider
        #default="{ errors }"
        name="Lokasi"
        rules="required"
      >
        <v-select
          id="v-category"
          v-model="form.type"
          :options="listType"
          :state="errors.length > 0 ? false : null"
          :clearable="false"
          :searchable="false"
          required
        >
          <template #option="{ label }">
            <span class="text-capitalize">{{ label }}</span>
          </template>
          <template #no-options="">
            Type tidak ditemukan.
          </template>
        </v-select>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Is Active -->
    <b-form-group
      label="Status"
      label-for="v-is_active"
      label-cols-md="4"
    >
      <template #label>
        Status
        <b-badge
          variant="light-secondary"
        >
          Wajib
        </b-badge>
      </template>
      <validation-provider
        #default="{ errors }"
        name="Status"
        rules="required"
      >
        <div class="demo-inline-spacing">
          <b-form-radio
            v-model="form.is_active"
            class="mt-0"
            name="is_active"
            value="1"
          >
            Aktif
          </b-form-radio>
          <b-form-radio
            v-model="form.is_active"
            class="mt-0"
            name="is_active"
            value="0"
          >
            Tidak Aktif
          </b-form-radio>
        </div>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <hr>

    <h3>Informasi lainnya</h3>

    <!-- Image -->
    <b-form-group
      label="Foto Koleksi"
      label-for="v-image"
      label-cols-md="4"
    >
      <validation-provider
        #default="{ errors }"
        name="Icon"
      >
        <form-image
          id="v-image"
          v-model="form.image"
          label="Pilih Foto"
          :state="errors.length > 0 ? false : null"
          width-full
          aspect-ratio="2/1"
          @finish="setPhotoFile"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Urutan -->
    <b-form-group
      label="Urutan"
      label-for="v-position"
      label-cols-md="4"
    >
      <validation-provider
        #default="{ errors }"
        name="Urutan"
      >
        <b-form-input
          id="v-position"
          v-model="form.position"
          :state="errors.length > 0 ? false : null"
          type="number"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Category -->
    <b-form-group
      label="Kategori"
      label-for="v-category"
      label-cols-md="4"
    >
      <validation-provider
        #default="{ errors }"
        name="kategori"
      >
        <v-select
          id="v-category"
          v-model="form.category_id"
          label="name"
          :options="subCategoryList"
          :reduce="item => item.id"
          :state="errors.length > 0 ? false : null"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        />
        <small class="text-muted">Catatan: Setiap Koleksi tidak dapat memiliki kategori yang sama</small>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Description -->
    <b-form-group
      label="Deskripsi"
      label-for="v-description"
      label-cols-md="4"
    >
      <validation-provider
        #default="{ errors }"
        name="Deskripsi"
      >
        <quill-editor
          id="v-description"
          v-model="form.description"
          class="is-invalid"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </validation-observer>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import {
  BFormGroup,
  BFormInput,
  VBTooltip,
  BFormRadio, BBadge,
} from 'bootstrap-vue'

import FormImage from '@/layouts/components/custom/FormImage.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// Vee Validate
import { required } from '@validations'

import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import Ripple from 'vue-ripple-directive'
// Quill Editor
// eslint-disable-next-line
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import { quillEditor } from 'vue-quill-editor'

import vSelect from 'vue-select'

export default {
  name: 'CollectionDataForm',
  components: {
    BBadge,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    FormImage,
    quillEditor,
    vSelect,
    BFormRadio,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  mixins: [togglePasswordVisibility],
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    ...mapState('collections', ['listType']),
    ...mapGetters('category', ['subCategoryList']),
  },
  watch: {
    form: {
      handler(val) {
        if (val.title) {
          const text = this.form.title.toLowerCase()
          this.form.slug = text.replaceAll(' ', '-')
        }
      },
      deep: true,
    },
  },
  async mounted() {
    await this.getCategoryList()
  },
  methods: {
    ...mapActions('category', ['getCategoryList']),
    setPhotoFile(file) {
      if (file) {
        this.form.imageFile = file
      }
    },
    async validationForm() {
      const response = await this.$refs.simpleRules.validate()
      return response
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
